import script from "./QueryTableLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueryTableLite.vue?vue&type=script&setup=true&lang=ts"

import "./QueryTableLite.vue?vue&type=style&index=0&id=056cb85a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056cb85a"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection});
